import { render, staticRenderFns } from "./TambahTipePinjaman.vue?vue&type=template&id=7ebe06c2&scoped=true&"
import script from "./TambahTipePinjaman.vue?vue&type=script&lang=js&"
export * from "./TambahTipePinjaman.vue?vue&type=script&lang=js&"
import style0 from "./TambahTipePinjaman.vue?vue&type=style&index=0&id=7ebe06c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebe06c2",
  null
  
)

export default component.exports